import React from 'react';
import './CustomDialog.css';

function CustomDialog({ message, onClose, type = 'info', onConfirm }) {
  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-box" onClick={(e) => e.stopPropagation()}>
        <div className={`dialog-icon ${type}`}>
          {type === 'success' ? '✓' : type === 'error' ? '✕' : type === 'confirm' ? '?' : 'ℹ'}
        </div>
        <p className="dialog-message">{message}</p>
        {type === 'confirm' ? (
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button className="dialog-btn" onClick={() => { onConfirm(); onClose(); }} style={{ backgroundColor: '#dc3545' }}>Yes</button>
            <button className="dialog-btn" onClick={onClose} style={{ backgroundColor: '#6c757d' }}>No</button>
          </div>
        ) : (
          <button className="dialog-btn" onClick={onClose}>OK</button>
        )}
      </div>
    </div>
  );
}

export default CustomDialog;
